/**
 * @module popup
 * @description Handles popup functionality for the annual dinner event using PopupMaker plugin.
 * @requires PUM - PopupMaker library
 *
 * localized from WordPress PHP theme
 * hcd_localized_object['annual-dinner-popup-message']() - function - returns the post object of the PopupMaker plugin's specific post for our annual dinner plugin so that we can pass the settings
 */

export const initPopup = () => {
	annualDinnerPopup();
};

const annualDinnerPopup = (delay = 2000) => {
	// console.log("annualDinnerPopup called");

	if (typeof PUM === "undefined") return;
	if (!PUM || !getAnnualDinnerPopupPost() || checkCookie("annualdinner-visit")) return;

	delay = getPopupSettings()["delay"] || delay;

	const srcParam = getURLParameter("src");
	if (srcParam !== "annualdinner") {
		return;
	}

	// console.log("srcParam", srcParam);

	addAnnualDinngerPopupClass();

	setTimeout(() => {
		const popupID = getAnnualDinnerPopupPost()["ID"];
		if (!popupID) {
			console.warn("Annual dinner popup post ID not found.");
			return;
		}
		PUM.open(popupID);
	}, delay);
};

const setAnnualDinnerCookie = () => {};

const checkCookie = (name) => {
	return document.cookie.split(";").some((cookie) => cookie.trim().startsWith(name + "="));
};
const getAnnualDinnerPopupPost = () => {
	return hcd_localized_object["annual-dinner-popup-message"];
};

const getPopupSettings = () => {
	console.log("gettings settings");
	if (!getAnnualDinnerPopupPost()) {
		// no post found
		return;
	}
	const popupPost = getAnnualDinnerPopupPost();
	// console.log("popupPost", popupPost);
	// console.log("jsonSettings", jsonSettings);
	let delay = parseInt(popupPost["open_delay"][0]);
	// console.log("open_delay", delay);

	if (isNaN(delay)) {
		delay = 2000;
	}

	const popupSettings = {
		delay,
	};

	if (popupSettings) {
		return popupSettings;
	}
	return null;
};

const getURLParameter = (paramName) => {
	const queryString = window.location.search;
	if (queryString.length === 0) return null;
	const urlParams = new URLSearchParams(queryString);
	const src = urlParams.get(paramName);
	if (src != null && src != undefined) {
		return src;
	}
	return null;
};

const addAnnualDinngerPopupClass = () => {
	const popupContainer = document.querySelector(".pum-container");
	if (!popupContainer) return;

	popupContainer.classList.add("annual-dinner-popup");
};
